<template>
  <!-- prettier-ignore -->
  <FormItem :error="error" :prop="fieldName">
    <span v-if="label !== undefined" slot="label" class="n-field-label">{{ $t(`label.${label}`) }}</span>
    <span v-if="customLabel !== undefined" slot="label" class="n-field-label">{{ customLabel }}</span>
    <input :value="originalValue" style="display: none;" />
    <div :class="modifiedIcon ? 'n-input-item-icon' : 'n-input-item'">
      <i-input v-model="displayValue" type="text" :placeholder="placeholder === undefined ? '' : this.$t(`label.${placeholder}`)" :disabled="disabled" @on-change="onChange" @on-focus="focusIn" @on-blur="focusOut" />
    </div>
    <Tooltip v-if="isModified" placement="right-start" :max-width="500" :content="initValue" transfer class="ml-2">
      <Icon custom="fas fa-pen" size="14" style="cursor: pointer;" />
    </Tooltip>
  </FormItem>
</template>

<script>
import Base from '../base';
import { percent } from '@/helpers/number';
import { isEmpty } from '@/helpers/utils';

export default Base.extend({
  name: 'NFieldPercent',
  props: {
    value: [String, Number],
    format: {
      type: String,
      default: '0.000 %',
    },
  },
  data() {
    return {
      originalValue: null,
      displayValue: null,
      isFocusing: false,
    };
  },
  computed: {
    isModified() {
      let v = isEmpty(this.value) ? null : percent(`${this.value}`, this.format);
      return this.showModifyIcon && this.initValue !== v;
    },
  },
  watch: {
    value() {
      if (!this.isFocusing) this.init();
    },
    originalValue() {
      if (this.originalValue !== this.stringValue(this.value)) {
        this.$emit('input', this.originalValue);
        this.$emit('on-change', this.originalValue);
      }
    },
  },
  created() {
    this.initValue = isEmpty(this.value) ? null : percent(`${this.value}`, this.format);
    this.init();
  },
  methods: {
    init() {
      this.originalValue = this.stringValue(this.value);
      if (isEmpty(this.originalValue)) {
        this.displayValue = this.originalValue;
        return;
      }
      if (this.originalValue !== '-' && isNaN(this.originalValue)) {
        this.originalValue = null;
        this.displayValue = null;
        return;
      }
      if (this.isCreate) this.displayValue = this.originalValue;
      else this.displayValue = percent(this.originalValue, this.format);
    },
    onChange() {
      this.displayValue = this.displayValue.trim();
      if (this.displayValue === this.originalValue) return;
      if (isEmpty(this.displayValue)) {
        this.originalValue = null;
        this.displayValue = null;
        return;
      }
      let isNumber = this.displayValue === '-' || !isNaN(this.displayValue);
      if (isNumber) {
        this.$nextTick(() => {
          this.originalValue = this.displayValue;
        });
      } else {
        this.$nextTick(() => {
          this.displayValue = this.originalValue;
        });
      }
    },
    focusIn() {
      this.isFocusing = true;
      if (this.isCreate) return;
      this.displayValue = this.originalValue;
    },
    focusOut() {
      if (this.isCreate || isEmpty(this.originalValue) || this.originalValue === '-') {
        this.isFocusing = false;
        return;
      }
      this.displayValue = percent(this.displayValue, this.format);
      this.isFocusing = false;
    },
    stringValue(v) {
      if (isEmpty(v)) return '';
      return typeof v === 'string' ? v.trim() : v.toString().trim();
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../base';
@import 'style';
</style>
